import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mobileNumberEnc'
})
export class MobileNumberEncPipe implements PipeTransform {
  transform(mobileNumber: string): any {
    return mobileNumber ? mobileNumber.substring(0, 2) + 'xxxx' + mobileNumber.substring(6) : '';
  }
}
